import Vue from 'vue'
import Vuex from 'vuex'
import projectsData from '@/data/projects.json'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    works: projectsData,
    words: [],
    cartIsOpen: false,
    showGrid: false,
    colors: {
      txt: '',
      bg: ''
    },
    user: {
      hasTouch: false
    }
  },
  mutations: {
    setWords (state, words) { state.words = words },
    openCart (state, isOpen) { state.cartIsOpen = isOpen },
    addToCart (state, id) {
      state.words = state.words.map(word => word.id === id ? { id: word.id, style: word.style, text: word.text, inCart: true } : word)
    },
    toggleGrid (state) { state.showGrid = !state.showGrid },
    setColors (state, { txt, bg }) {
      state.colors.txt = txt
      state.colors.bg = bg
    },
    userHasTouch (state) {
      state.user.hasTouch = true
    }
  },
  actions: { }
})
